import React from 'react'
import styled from '@emotion/styled'
import { Tooltip } from 'antd'
import { Ellipsis, EllipsisTooltip } from 'components'
import { colors, severityColors } from 'style/theme'
import { ShowStyledItems } from 'components'

const MoreCountNoBorder = styled.div(({ color }) => ({
	height: 30,
	width: '100%',
	lineHeight: '28px',
	color: color,
	fontSize: '0.9rem'
}))

function PageTooltip({url, errorDescription}){
	return (
		<>
			<EllipsisTooltip>{url}</EllipsisTooltip> 
			{ errorDescription && 
				<EllipsisTooltip style={{color: 'rgb(245, 100, 100)' }} >Error: {errorDescription}</EllipsisTooltip>
			}
		</>
	)
}

export default [
	{
		title: 'PAGE',
		dataIndex: 'url',
		width: '50%',
		render(url, record){
			return (
				<Tooltip placement="right" title={<PageTooltip url={url}/>}>
					<a target="_blank" href={url} >
						<Ellipsis>{url}</Ellipsis>
					</a>
				</Tooltip>
			)
		}
	},
	{
		title: 'REGRESSIONS',
		dataIndex: 'regressions',
		align: 'center',
		render(regressions) {
			let itemCount = 0;
			let errCodes = regressions.map((item) => {
				itemCount += item.count;
				item.color = severityColors[item.severity.toLowerCase()];
				return item;
			})
			return (
				<ShowStyledItems
					moreItems={errCodes}
					renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{itemCount}</MoreCountNoBorder>}
				/>
			)
		}
	},
	{
		title: 'FIXED',
		dataIndex: 'fixed',
		align: 'center',
		render(fixed) {
			let itemCount = 0;
			let errCodes = fixed.map((item) => {
				itemCount += item.count;
				item.color = severityColors[item.severity.toLowerCase()];
				return item;
			})
			return (
				<ShowStyledItems
					moreItems={errCodes}
					renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{itemCount}</MoreCountNoBorder>}
				/>
			)
		}
	},
	{
		title: 'NO CHANGE',
		dataIndex: 'no_change',
		align: 'center',
		render(noChange) {
			let itemCount = 0;
			let errCodes = noChange.map((item) => {
				itemCount += item.count;
				item.color = severityColors[item.severity.toLowerCase()];
				return item;
			})
			return (
				<ShowStyledItems
					moreItems={errCodes}
					renderCounter={count => <MoreCountNoBorder color={colors.brandDark}>{itemCount}</MoreCountNoBorder>}
				/>
			)
		}
	}
]

